import { Search, SlidersHorizontal } from 'lucide-react';
import { Input } from '@/shared/components/ui/Input';
import { Select } from '@/shared/components/ui/Select';
import { STATUS_OPTIONS } from '../constants';

interface MeetingsFilterBarProps {
  search: string;
  status: string;
  onSearchChange: (v: string) => void;
  onStatusChange: (v: string) => void;
}

export function MeetingsFilterBar({
  search,
  status,
  onSearchChange,
  onStatusChange,
}: MeetingsFilterBarProps) {
  const statusOptions = [{ value: '', label: 'All Statuses' }, ...STATUS_OPTIONS];

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-card border border-outline bg-surface p-3">
      <SlidersHorizontal className="h-4 w-4 shrink-0 text-on-surface-variant" />

      {/* Client-side search on title */}
      <div className="min-w-[220px] flex-1">
        <Input
          name="meeting-search"
          placeholder="Search meetings…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="h-4 w-4" />}
        />
      </div>

      <div className="w-44">
        <Select
          name="meeting-status-filter"
          options={statusOptions}
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
        />
      </div>
    </div>
  );
}
